<template>
  <v-app class="fill-height" fill-height >
    <cabecera/>
    <v-main style="background-color:#6D9886;">
    <v-container fluid  >
      <v-row align="center" align-content="center"    no-gutters justify="center" vertical="center" class="text-center">

        <v-col lg="6" md="6" cols="12">
          <v-card  color="#393E46">
            <v-card-text>
              <v-alert type="error" v-if="error" >{{error}}</v-alert>
              <v-row align="center" justify="center" class="text-center">
                <v-col cols="12">
                  <v-img src="@/assets/tunaywhitelogo.png" width="200" />
                </v-col>
              </v-row>
              <v-form ref="form" action="#" @submit.prevent="submit">
                <v-row align="center" justify="center">

                  <v-col lg="6" md="6" cols="12">
                    <v-text-field
                        id="email"
                        :counter="250"
                        name="puerta"
                        label="Código de Puerta"
                        value
                        required
                        color="#6D9886"
                        autofocus
                        v-model="puerta"
                    />
                  </v-col>
                </v-row>


                <v-row class="mb-0">
                  <v-col md="8" class="offset-md-4">
                    <v-btn @click="submit" class="primary">Login</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-img
            src="@/assets/loadtunay.gif"

        />
      </v-overlay>
    </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>
import axios from 'axios';
import store from "@/store";
import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";

export default {
  components: {
    cabecera,
    piepagina,

  },
  data() {
    return {
      puerta:'',
      getips:'',
      overlay:false,
      cssProps:{
        backgroundImage :`url('https://tunaydisenio.s3.sa-east-1.amazonaws.com/fondo-tunay.webp')`,
        height:'100%'
      },
      error: null
    };
  },
  mounted() {

  },
  methods: {

    submit() {
      this.overlay = true;


            axios.get("puerta/"+this.puerta)
                .then(response => {
                  let puertar = response.data;
                  if(puertar.existe){
                    if(puertar.esEvento){
                      store.dispatch("fetchCliente",puertar.cliente)
                      this.$router.push({ path: "/puerta/cliente" });

                    }else {
                      store.dispatch("fetchNegocio",puertar.negocio)
                      this.$router.push({ path: "/puerta/ver" });

                    }

                  }
                  this.overlay = false;
                })
                .catch(error => {
                  this.error = "Hubo un error";
                  this.overlay = false;
                  console.log(error);
                });

    }
  }
};
</script>
